import React from "react";
import "./style.scss";

const defaultErrorTitle = "Page Error";
const defaultErrorMessage = "Something went wrong please try again later.";

const Error = ({
  errorTitle = defaultErrorTitle,
  error = defaultErrorMessage,
}) => (
  <section className="error-message-container">
    <p className="error-title">{errorTitle.toUpperCase()}</p>
    <p className="error-message">{error.toUpperCase()}</p>
  </section>
);

export default Error;
